export default "__VITE_ASSET__DdBIA7Hu__"